module.exports = __webpack_public_path__ + "img/alpaClass.463cb4fd.svg";